const ID = 'callout';

export default ID;
